module.exports = __webpack_public_path__ + "static/media/UMA-logo.5dd8bcd6.png";